// extracted by mini-css-extract-plugin
export default {"container":"U1-z"};